import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RatingBodyType, RatingGuard } from 'src/app/gaurd/rating.guard';
import { ExteriorComponent } from './exterior/exterior.component';
import { FrameComponent } from './frame/frame.component';
import { GradingComponent } from './grading/grading.component';
import { InteriorComponent } from './interior/interior.component';
import { MajorOptionsComponent } from './major-options/major-options.component';
import { MechanicsComponent } from './mechanics/mechanics.component';
import { RatingComponent } from './rating.component';
import { RepairCostComponent } from './repair-cost/repair-cost.component';

const routes: Routes = [
  {
    path: '',
    component: RatingComponent,
    canActivate: [RatingBodyType],
    canDeactivate: [RatingGuard],
    children: [
      {
        path: '',
        pathMatch: 'prefix',
        redirectTo: 'exterior',
      },
      {
        path: 'exterior',
        component: ExteriorComponent,
      },
      {
        path: 'interior',
        component: InteriorComponent,
      },
      {
        path: 'mechanics',
        component: MechanicsComponent,
      },
      {
        path: 'frame',
        component: FrameComponent,
      },
      {
        path: 'major-options',
        component: MajorOptionsComponent,
      },
      {
        path: 'grading',
        component: GradingComponent,
      },
      {
        path: 'repair-cost',
        component: RepairCostComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RatingRoutingModule {}
